export default {
  hide: () => {},
}
